import { Component } from '@angular/core';
import { FinegrainRolesService } from '../../common/services/finegrain-roles/finegrain-roles.service';
import { TranslationService } from '../../common/services/languages/translation.service';
import { NgIf } from '@angular/common';
import { ReportFormComponent } from '../report-form/report-form.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-report-main',
    templateUrl: './report-main.component.html',
    styleUrls: ['./report-main.component.scss'],
    imports: [NgIf, ReportFormComponent, TranslatePipe]
})
export class ReportMainComponent {
  constructor(
    public translate: TranslationService,
    private fineGrainService: FinegrainRolesService) {   }
  /**
  * Property deletmine is report authorized
  **/
  public get isReportUser(): boolean {
    return this.fineGrainService.getPortalPermissions('report');
  }
}
